import { ISnotrRoute } from '..';

export default [
  {
    path: '/product-groups',
    name: 'ProductGroups',
    meta: {
      title: 'TabTitle.productGroups',
      applicationMode: 'InvoicingMode',
    },
    component: () => import('@/pages/product-groups.vue'),
  },
  {
    path: '/product-groups/list-edit',
    name: 'ProductGroupsListEdit',
    meta: {
      title: 'TabTitle.productGroupsListEdit',
      applicationMode: 'InvoicingMode',
    },
    component: () => import('@/components/ProductGroup/ProductGroupListEdit.vue'),
  },
] as ISnotrRoute[];
